export const unwrapPaginatedResponse = (response) => {
  if (response?.pagination != null && Array.isArray(response?.data)) {
    return {
      data: response.data,
      pagination: response.pagination,
    };
  }

  if (response?.success && response?.pagination != null && Array.isArray(response?.data)) {
    return {
      data: response.data,
      pagination: response.pagination,
    };
  }

  if (Array.isArray(response)) {
    const total = response.length;
    return {
      data: response,
      pagination: {
        page: 1,
        limit: total || 10,
        total,
        totalPages: 1,
      },
    };
  }

  if (Array.isArray(response?.data)) {
    const total = response.data.length;
    return {
      data: response.data,
      pagination: response.pagination || {
        page: 1,
        limit: total || 10,
        total,
        totalPages: 1,
      },
    };
  }

  return {
    data: [],
    pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  };
};

export const buildPaginationParams = ({ page = 1, limit = 10, filters } = {}) => {
  const params = {
    page,
    limit,
  };
  if (filters != null && Object.keys(filters).length > 0) {
    params.filters = typeof filters === 'string' ? filters : JSON.stringify(filters);
  }
  return params;
};
